import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, propTypes as formPropTypes } from 'redux-form';

import DisplayAllotments from './DisplayAllotments';

import { getFutureAllotments } from '../../gamedayAccount/selectors';
import { saveFutureAllotments } from '../actions';

import { newAllotmentTypes } from '../../types/allotments';

export const FutureAllotments = ({
  futureAllotments,
  saveFutureAllotments,
  isFutureNow,
  submitting,
  valid,
  change,
  reset,
  handleSubmit,
  allotmentForm
}) => (
  <DisplayAllotments
    type='future'
    allotments={futureAllotments}
    allotmentForm={allotmentForm}
    isFutureNow={isFutureNow}
    saveAllotments={saveFutureAllotments}
    submitting={submitting}
    valid={valid}
    change={change}
    reset={reset}
    handleSubmit={handleSubmit}
  />
);

FutureAllotments.defaultProps = {
  futureAllotments: {}
};

FutureAllotments.propTypes = {
  ...formPropTypes,
  futureAllotments: newAllotmentTypes,
  saveFutureAllotments: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  allotmentForm: state.form.allotmentForm,
  futureAllotments: getFutureAllotments(state, true)
});

const connector = connect(mapStateToProps, { saveFutureAllotments });

export default reduxForm({
  form: 'allotmentForm'
})(connector(FutureAllotments));
